import { metadata } from './support'

export const JOB_STATES = {
  PENDING: 'Pending',
  RUNNING: 'Running',
  FINISHED: 'Finished'
}

// Schedules a backend job that writes a CSV of every member (with their roles
// per folder) into a new folder named `folder` directly under `projectId`.
// Only available in metadata v4; the backend rejects the call unless both
// body fields are present, even though the Swagger marks them optional. An
// empty principalType (still present) lists every principal: users, API
// accounts, ...
export const requestMemberReport = (projectId: string, folder: string) =>
  metadata.postJson(
    `metadata/project/${projectId}/member/list`,
    { folder, principalType: '' },
    4
  )

export const getJob = (jobId: string) =>
  metadata.getJson(`process/job/${jobId}`, 3)
